module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_down_gray600-2daa24ae0a56053654aa2ca0d54e284d.svg";